import { Directive, Injector, Input, OnInit } from "@angular/core";
import { EvaSubnav } from "@shopping-angular-components/eva-subnav";
import { Module } from "projects/common/model/ModuleModel";
import { ScreenType } from "projects/common/model/ScreenType";
import { LandingModelService } from "projects/common/services/landingModel.service";
import { UpaTrackingData } from "projects/common/services/upa.service";
import { BackgroundData } from "../background/background.component";
import { BreadcrumbData } from "../breadcrumb/breadcrumb.component";
import { ButtonOptions } from "../eva-button/eva-button.component";
import { MainTitle } from "../main-title/main-title.component";
import { PromotionItem } from "../offers/offer-card-data.model";
import { SboxModule } from "../sbox/sbox.component";
import { TagTextData } from "../tag-text/tag-text.component";

@Directive()
export abstract class CommonHeaderComponent implements OnInit {
  @Input() backgroundModule?: { data: BackgroundData };
  @Input() sboxModule: SboxModule;
  @Input() mainTitleModule?: { data?: MainTitle };
  @Input() titleInNavBar: boolean = false;
  @Input() upaTrackingData: UpaTrackingData;

  @Input() product: string = 'nymeria-gui';
  @Input() flow: string = 'landing';
  @Input() module: HeaderModule<HeaderData>;

  @Input() shifuProduct: string;

  screenType: ScreenType;

  htmlId: string;
  titlePillLogo: string;
  position: number;
  link?: string;
  scrollTarget?: string;
  subnavModule: EvaSubnav;
  backgroundColor?: string;
  textShadow: boolean;
  backgroundPosition: string;
  subnavViewType: 'DEFAULT' | 'PILLS' = 'DEFAULT';

  public landingModelService: LandingModelService;

  constructor(private injector: Injector) {
    this.landingModelService = this.injector.get(LandingModelService);
  }

  ngOnInit() {
    this.screenType = this.landingModelService.getLandingModel().device.type;
    this.backgroundPosition = this.landingModelService.getLandingModel().backgroundPosition;

    this.initCommonProps();

    if (this.module.data.background || this.backgroundModule) {
      this.backgroundModule = this.backgroundModule || { data: this.module.data.background };
    }
    if (this.module.data.main_title || this.mainTitleModule) {
      this.mainTitleModule = this.mainTitleModule != null ? this.mainTitleModule : { data: this.module.data.main_title };
    }
    if (this.module.data.sbox || this.sboxModule) {
      this.sboxModule = this.sboxModule || this.module.data.sbox;
    }
    if (this.module.data.subnav) {
      this.subnavModule = this.module.data.subnav;
      this.subnavViewType = this.subnavModule?.options?.view_type || 'DEFAULT';
    }
  }

  initCommonProps() {
    this.link = this.module.data.link;
    this.textShadow = this.module.data?.text_shadow ?? true;
    this.scrollTarget = this.module.data.scroll_target;
    this.backgroundColor = this.module.background_color;
    this.titlePillLogo = this.module.data.title_pill_logo;
    this.position = this.module.position;
    this.htmlId = this.module.html_id;
  }

  updateData() {
    this.initCommonProps();

    this.backgroundModule = { data: this.module.data.background };
    this.mainTitleModule = { data: this.module.data.main_title };
    this.subnavModule = this.module.data.subnav;
  }
}

export interface ProductMainTitle {
  pre_title?: TagTextData;
  title?: TagTextData;
  sub_title?: TagTextData;
  css_options?: any;
  review: Review;
  reference_price: ProductReferencePrice;
  show_map_link: boolean;
}

export interface DownloadAppData {
  qr_image?: string;
  android_data?: StoreData;
  ios_data?: StoreData;
  mobile_button: ButtonOptions;
  link_to_site: ButtonOptions;
  title?: TagTextData;
  subtitle?: TagTextData;
  background_max_height?: string;
}

export interface StoreData {
  store_image?: string;
  download_link?: string;
}

export interface ProductReferencePrice {
  reference_text: string;
  reference_price: string;
  gross_reference_price: string;
  reference_currency: string;
  reference_date: string;
  promotions_list?: PromotionItem[];
  button: ButtonOptions;
  payments: string;
}

export interface HeaderModule<T> extends Module<T> {
  background_color?: string;
  html_id: string;
}

export interface HeaderData {
  breadcrumbs: BreadcrumbData[];
  background: BackgroundData;
  main_title: MainTitle;
  product_main_title: ProductMainTitle;
  sbox: SboxModule;
  subnav: EvaSubnav;
  move_first_section: boolean;
  text_shadow: boolean;
  link: string;
  open_link_in_new_tab: boolean;
  scroll_target: string;
  title_pill_logo: string;
  view_type: 'VIEW_1' | 'VIEW_2' | 'VIEW_3' | 'HEADING_APP' | 'HEADING_VIDEO' | undefined
  download_app_data: DownloadAppData;
  youtube_video_id: string;
  youtube_video_loop: boolean;
  youtube_video_auto_play: boolean;
}

export interface Review {
  name: string;
  score: string;
  comments_text: string;
  comments_button: ButtonOptions;
}
